// extracted by mini-css-extract-plugin
export default {"alert-title":"CapeV_alert-title__pNK7S","alert-prompt":"CapeV_alert-prompt__xJmcH"};